import { cn } from '@/lib/utils';
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackMetaEvent } from '../lib/metaPixel';
type TrackingEvent = 'Lead' | 'InitiateCheckout';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  trackingEvent?: TrackingEvent;
}
export function CtaButton({
  children,
  className = '',
  href = '#oferta',
  size = 'lg',
  trackingEvent
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <motion.a href={href} onClick={() => {
    if (trackingEvent) {
      trackMetaEvent(trackingEvent);
    }
  }} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={cn(`group inline-flex items-center justify-center gap-2 rounded-full bg-brand font-bold text-white shadow-lg shadow-brand/30 transition-colors hover:bg-brand-dark ${sizeClasses} ${className}`, "text-[#0a7d45]", "text-[#14261d] bg-[#e8f6ee]")} data-id="element-27" data-mp="10922uxdrstww">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-28" data-mp="35zimee7ne4q3" />
    </motion.a>;
}